import { render, staticRenderFns } from "./School.vue?vue&type=template&id=ad6f7c60&scoped=true"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"
import style0 from "./School.vue?vue&type=style&index=0&id=ad6f7c60&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6f7c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad6f7c60')) {
      api.createRecord('ad6f7c60', component.options)
    } else {
      api.reload('ad6f7c60', component.options)
    }
    module.hot.accept("./School.vue?vue&type=template&id=ad6f7c60&scoped=true", function () {
      api.rerender('ad6f7c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/schools/School.vue"
export default component.exports